import { DeviceManifest } from '@rapoo/device-sdk'

export const fullSize108: DeviceManifest['layout'] = {
  unit: 32,
  keys: [
    [
      {
        key: 1,
        keywords: 'Esc',
      },
      {
        key: 2,
        x: 1,
        keywords: 'F1',
      },
      {
        key: 3,
        keywords: 'F2',
      },
      {
        key: 4,
        keywords: 'F3',
      },
      {
        key: 5,
        keywords: 'F4',
      },
      {
        key: 6,
        x: 0.5,
        keywords: 'F5',
      },
      {
        key: 7,
        keywords: 'F6',
      },
      {
        key: 8,
        keywords: 'F7',
      },
      {
        key: 9,
        keywords: 'F8',
      },
      {
        key: 10,
        x: 0.5,
        keywords: 'F9',
      },
      {
        key: 11,
        keywords: 'F10',
      },
      {
        key: 12,
        keywords: 'F11',
      },
      {
        key: 13,
        keywords: 'F12',
      },
      {
        key: 14,
        x: 0.5,
        keywords: 'PrintScreen',
      },
      {
        key: 15,
        keywords: 'ScrollLock',
      },
      {
        key: 16,
        keywords: 'PauseBreak',
      },
    ],
    [
      {
        key: 17,
        keywords: '~_`',
      },
      {
        key: 18,
        keywords: '!_1',
      },
      {
        key: 19,
        keywords: '@_2',
      },
      {
        key: 20,
        keywords: '#_3',
      },
      {
        key: 21,
        keywords: '$_4',
      },
      {
        key: 22,
        keywords: '%_5',
      },
      {
        key: 23,
        keywords: '^_6',
      },
      {
        key: 24,
        keywords: '&_7',
      },
      {
        key: 25,
        keywords: '*_8',
      },
      {
        key: 26,
        keywords: '(_9',
      },
      {
        key: 27,
        keywords: ')_0',
      },
      {
        key: 28,
        keywords: '__-',
      },
      {
        key: 29,
        keywords: '+_=',
      },
      {
        key: 30,
        w: 2,
        keywords: 'BackSpace',
      },
      {
        key: 31,
        x: 0.5,
        keywords: 'Insert',
      },
      {
        key: 32,
        keywords: 'Home',
      },
      {
        key: 33,
        keywords: 'PgUp',
      },
      {
        key: 34,
        x: 0.5,
        keywords: 'NumLock',
      },
      {
        key: 35,
        keywords: '/',
      },
      {
        key: 36,
        keywords: '*',
      },
      {
        key: 37,
        keywords: '-',
      },
    ],
    [
      {
        key: 38,
        w: 1.5,
        keywords: 'Tab',
      },
      {
        key: 39,
        keywords: 'Q',
      },
      {
        key: 40,
        keywords: 'W',
      },
      {
        key: 41,
        keywords: 'E',
      },
      {
        key: 42,
        keywords: 'R',
      },
      {
        key: 43,
        keywords: 'T',
      },
      {
        key: 44,
        keywords: 'Y',
      },
      {
        key: 45,
        keywords: 'U',
      },
      {
        key: 46,
        keywords: 'I',
      },
      {
        key: 47,
        keywords: 'O',
      },
      {
        key: 48,
        keywords: 'P',
      },
      {
        key: 49,
        keywords: '{_[',
      },
      {
        key: 50,
        keywords: '}_]',
      },
      {
        key: 51,
        w: 1.5,
        keywords: '|_\\',
      },
      {
        key: 52,
        x: 0.5,
        keywords: 'Delete',
      },
      {
        key: 53,
        keywords: 'End',
      },
      {
        key: 54,
        keywords: 'PgDn',
      },
      {
        key: 55,
        x: 0.5,
        keywords: '7_Home',
      },
      {
        key: 56,
        keywords: '8_↑',
      },
      {
        key: 57,
        keywords: '9_PgUp',
      },
      {
        key: 58,
        h: 2,
        keywords: '+',
      },
    ],
    [
      {
        key: 59,
        w: 1.75,
        keywords: 'CapsLock',
      },
      {
        key: 60,
        keywords: 'A',
      },
      {
        key: 61,
        keywords: 'S',
      },
      {
        key: 62,
        keywords: 'D',
      },
      {
        key: 63,
        keywords: 'F',
      },
      {
        key: 64,
        keywords: 'G',
      },
      {
        key: 65,
        keywords: 'H',
      },
      {
        key: 66,
        keywords: 'J',
      },
      {
        key: 67,
        keywords: 'K',
      },
      {
        key: 68,
        keywords: 'L',
      },
      {
        key: 69,
        keywords: ':_;',
      },
      {
        key: 70,
        keywords: '"_\'',
      },
      {
        key: 71,
        w: 2.25,
        keywords: 'Enter',
      },
      {
        key: 72,
        x: 4,
        keywords: '4_←',
      },
      {
        key: 73,
        keywords: '5',
      },
      {
        key: 74,
        keywords: '6_→',
      },
    ],
    [
      {
        key: 75,
        w: 2.25,
        keywords: 'Shift_L',
      },
      {
        key: 76,
        keywords: 'Z',
      },
      {
        key: 77,
        keywords: 'X',
      },
      {
        key: 78,
        keywords: 'C',
      },
      {
        key: 79,
        keywords: 'V',
      },
      {
        key: 80,
        keywords: 'B',
      },
      {
        key: 81,
        keywords: 'N',
      },
      {
        key: 82,
        keywords: 'M',
      },
      {
        key: 83,
        keywords: '<_,',
      },
      {
        key: 84,
        keywords: '>_.',
      },
      {
        key: 85,
        keywords: '?_/',
      },
      {
        key: 86,
        w: 2.75,
        keywords: 'Shift_R',
      },
      {
        key: 87,
        x: 1.5,
        keywords: '↑',
      },
      {
        key: 88,
        x: 1.5,
        keywords: '1_End',
      },
      {
        key: 89,
        keywords: '2_↓',
      },
      {
        key: 90,
        keywords: '3_PgDn',
      },
      {
        key: 91,
        h: 2,
        keywords: 'NumEnter',
      },
    ],
    [
      {
        key: 92,
        w: 1.25,
        keywords: 'Ctrl_L',
      },
      {
        key: 93,
        w: 1.25,
        keywords: 'Win_L',
      },
      {
        key: 94,
        w: 1.25,
        keywords: 'Alt_L',
      },
      {
        key: 95,
        w: 6.25,
        keywords: 'Space_L',
      },
      {
        key: 96,
        w: 1.25,
        keywords: 'Alt_R',
      },
      {
        key: 97,
        w: 1.25,
        keywords: 'Win_R',
      },
      {
        key: 98,
        w: 1.25,
        keywords: 'Menu',
      },
      {
        key: 99,
        w: 1.25,
        keywords: 'Ctrl_R',
      },
      {
        key: 100,
        x: 0.5,
        keywords: '←',
      },
      {
        key: 101,
        keywords: '↓',
      },
      {
        key: 102,
        keywords: '→',
      },
      {
        key: 103,
        x: 0.5,
        w: 2,
        keywords: '0_Ins',
      },
      {
        key: 104,
        keywords: '._Del',
      },
      {
        key: 105,
        x: 2,
        keywords: 'Fn',
      },
    ],
  ],
}
